import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { getMonthDayYear } from '../../../../utils/func';
import {
  CategoryContainer,
  ContentBox,
  ContentBoxTitle,
  ContentBoxGap,
  ContentBoxInfoColumn,
  ContentBoxSubTitle,
  ContentBoxText,
} from './css';

export const PickupDetails = ({ formData }) => {
  const {
    pickupDate,
    specialInstructions,
    closingTime,
    readyTime,
    droppingFreightOff,
    regularScheduledPickup,
  } = formData;

  return (
    <CategoryContainer>
      <ContentBox>
        <ContentBoxTitle>{t('General')}</ContentBoxTitle>
        <ContentBoxGap>
          <ContentBoxInfoColumn>
            <ContentBoxSubTitle>{t('DroppingFreightOffTitle')}</ContentBoxSubTitle>
            <ContentBoxText>{droppingFreightOff.name}</ContentBoxText>
          </ContentBoxInfoColumn>
          <ContentBoxInfoColumn>
            <ContentBoxSubTitle>{t('RegularScheduledPickupTitle')}</ContentBoxSubTitle>
            <ContentBoxText>{regularScheduledPickup.name}</ContentBoxText>
          </ContentBoxInfoColumn>
          {!regularScheduledPickup.value && (
            <>
              <ContentBoxInfoColumn>
                <ContentBoxSubTitle>{t('PickupDate')}</ContentBoxSubTitle>
                <ContentBoxText>{getMonthDayYear(pickupDate)}</ContentBoxText>
              </ContentBoxInfoColumn>
              <ContentBoxInfoColumn>
                <ContentBoxSubTitle>{t('ReadyTime')}</ContentBoxSubTitle>
                <ContentBoxText>
                  {readyTime.hours}
                  :
                  {readyTime.minutes}
                  {readyTime.amOrPm.toLowerCase()}
                </ContentBoxText>
              </ContentBoxInfoColumn>
              <ContentBoxInfoColumn>
                <ContentBoxSubTitle>{t('ClosingTime')}</ContentBoxSubTitle>
                <ContentBoxText>
                  {closingTime.hours}
                  :
                  {closingTime.minutes}
                  {closingTime.amOrPm.toLowerCase()}
                </ContentBoxText>
              </ContentBoxInfoColumn>
            </>
          )}
        </ContentBoxGap>
      </ContentBox>

      <ContentBox>
        <ContentBoxTitle>{t('AdditionalNotes')}</ContentBoxTitle>
        {specialInstructions && (
          <ContentBoxText>
            {specialInstructions}
          </ContentBoxText>
        )}
      </ContentBox>
    </CategoryContainer>
  );
};

PickupDetails.propTypes = {
  formData: PropTypes.shape({
    pickupDate: PropTypes.instanceOf(Date),
    specialInstructions: PropTypes.string,
    closingTime: PropTypes.shape({
      hours: PropTypes.number,
      minutes: PropTypes.number,
      amOrPm: PropTypes.oneOf(['AM', 'PM']),
    }),
    readyTime: PropTypes.shape({
      hours: PropTypes.number,
      minutes: PropTypes.number,
      amOrPm: PropTypes.oneOf(['AM', 'PM']),
    }),
    droppingFreightOff: PropTypes.shape({
      name: PropTypes.string,
    }),
    regularScheduledPickup: PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.bool,
    }),
  }),
};

export default PickupDetails;
